<script>
    import { useVuelidate } from '@vuelidate/core'

    export default {
        name: 'form-input-text',
        setup () { return { v$: useVuelidate() } },


        props: {
            value: {
                type: String,
                required: true
            },
            inputId: {
                type: String,
                required: false
            },
            inputType: {
                type: String,
                required: false
            },
            inputClass: {
                type: String,
                required: false
            },
            icon: {
                type: String,
                required: false
            },
            lazyValidation: {
                type: Boolean,
                required: false
            },
            validateUponBlur: {
                type: Boolean,
                required: false
            },
            label: {
                type: String,
                default: ''
            },
            hideLabel: {
                type: Boolean,
                default: false
            },
            v: {
                type: Object,
                required: true
            },
            isDisabled: {
                type: Boolean,
                default: false
            },
            hideErrors: {
                type: Boolean,
                default: false,
                required: false
            },
            
            focus: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                initialValue: this.value,
                isModified: false
            };
        },

        computed: {
            text: {
                get() {
                    return this.value;
                },

                set(value) {
                    if (this.lazyValidation !== undefined && this.lazyValidation)
                        this.v.$touch();
                    this.$emit("update:value", value);
                }
            },
            
            showIcon: function () {
                return this.myIcon !== undefined && this.myIcon !== null && this.myIcon.length > 0;
            },
            myInputType: {
                get() {
                    if (this.inputType !== undefined && this.inputType !== null && this.inputType.length > 0)
                        return this.inputType;
                    else return 'text';
                }
            },
            
            myIcon: function () {
                if (this.isSuccess())
                    return "icon-ok green";
                else return this.icon;
            },
            myComputedClasses: function () {
                let classes = "";
                if (this.inputClass !== undefined && this.inputClass !== null && this.inputClass.length > 0)
                    classes = this.inputClass;
                if (this.v.$dirty && this.v.$invalid)
                classes += " validation_error";
                return classes;
            }
           
            
        },

        mounted: function() {
            if (this.focus) {
                this.$refs.input.focus();
            }

            // Listen for the address-changed event
            PubSub.subscribe("DeliveryAddress.SelectedDeliveryAddressWasChanged", this.resetInitialValue);
        },
        methods: {
            isSuccess() {
                return !this.v$.$invalid && this.v$.$dirty;
            },
            onBlur(event) {
             
                this.$emit('blur', event);
                let me = this;
                if (this.validateUponBlur !== undefined && this.validateUponBlur) {
                    this.v.$touch();
                    this.v.$validate().then(() => {
                        if (me.value !== me.initialValue) {
                            me.$emit('value-changed', me.value);
                            me.resetInitialValue();
                        }
                    });
                }
            },
            resetInitialValue(event, data) {
                this.initialValue = this.value;
                this.isModified = false;
            }
        },
        watch: {
            text(newValue, oldValue) {
                this.isModified = newValue !== this.initialValue;
            }
        },

        beforeUnmount: function () {
            // Remove the event listener
            PubSub.unsubscribe("DeliveryAddress.SelectedDeliveryAddressWasChanged");
        },
        emits: ['blur', 'update:value', 'value-changed']
    };
</script>

<template>

    <div class="form-group" :class="{'form-group-error' : v.$error, 'ok' : !v.$invalid && v.$dirty}">
        <i :class="{'icon-star': !(!v.$invalid && v.$dirty), 'icon-ok green': !v.$invalid && v.$dirty} " v-if="showIcon"></i>
        <input type="text" :id="inputId" :disabled="isDisabled" :type="myInputType" class="form-control" @input="$emit('update:value', $event.target.value)"
               :class="myComputedClasses" :placeholder="label" v-model="text" ref="input" @blur="onBlur($event)">
        <label v-if="!hideLabel" :for="inputId" class="control-label">{{ label }}</label>
        <div class="error-placeholder" v-if="!hideErrors">
            <span class="error-line" v-for="error of v.$errors" :key="error.$uid">{{error.$message}}</span>
        </div>
    </div>

</template>

<style lang="scss">

    .customer-registration .fixed-error-height{
        & .error-placeholder {
            min-height: 25px;
        }
        & .error-line{
            color:red;
            margin-right:5px;
            font-size:12px;
        }

        & .form-group {
            margin-bottom: 0px;
        }        
    }

    .create-new-delivery-address-container{
        & .error-placeholder {
            min-height: 25px;
        }
        & .reg-textbox {
            margin-top: 0px;
        }
        & .error-line {
            color: red;
            margin-right: 5px;
            font-size: 12px;
        }

        & .form-group {
            margin-bottom: 0px;
        }
    }
</style>